import React from 'react';
import Icon from '@ant-design/icons';
import { ReactComponent as EditIcon }  from '../../assets/icons/icon_edit.svg';

const EditPencilIcon=(props)=>{
    return <Icon component={() => <EditIcon />} {...props}/>
}

export default EditPencilIcon;